import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Modal } from 'components/layout/modal/Modal';
import { Portal } from 'components/other/portal/Portal';
import { Transition } from 'components/other/transition/Transition';
import { closeReview, selectReview } from './review.slice';
import { ReviewBody } from './reviewBody/ReviewBody';

export const Review = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const review = useAppSelector(selectReview);

  return (
    <Transition active={review.ui.reviewOpened} timeout={300}>
      {(transitionStyles) => (
        <Portal blocked>
          <Modal
            className={transitionStyles}
            onOverlayClick={() => dispatch(closeReview())}
          >
            <ReviewBody />
          </Modal>
        </Portal>
      )}
    </Transition>
  );
};
